import { useParams } from 'react-router-dom';

import BotApi from 'api/bot';
import BotContentPage from './BotContentPage';

import withContentLoader from 'components/ui/withContentLoader';

const fetchData = async ({ routeMatch }) => {
  const { params } = routeMatch;
  return await BotApi.get(params.botId);
};

const BotContent = () => {
  const { botId } = useParams();

  const Content = withContentLoader(
    ({ data }) => {
      data.price = parseFloat(data.price);
      return <BotContentPage bot={data || {}} />;
    },
    { name: `bot-${botId}-content`, fetchData }
  );

  return <Content />;
};

export default BotContent;
